"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invertSafe = exports.invert = void 0;
// local
const getEntries_1 = require("./getEntries");
/**
 * Invert an object so that the values look up the keys.
 * If the object has an array as the value, each item in the array will be inverted.
 * @param obj - The object to invert
 * @param throwOnDuplicate - When true, throw error if duplicate key detected
 * @returns The inverted object
 */
function invert(obj, throwOnDuplicate = true) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    // Invert
    (0, getEntries_1.getEntries)(obj).forEach(([key, instance]) => {
        // Ensure no undefined values
        if (instance === undefined) {
            throw new Error('inverse found undefined value, this is not supported');
        }
        // Handle array case
        if (Array.isArray(instance)) {
            instance.forEach((listKey) => {
                // Create a new entry
                if (!result[listKey]) {
                    result[listKey] = [key];
                }
                else {
                    // Add to existing
                    result[listKey].push(key);
                }
            });
        }
        else {
            // Ensure we do not overwrite duplicates
            if (result[instance] && throwOnDuplicate) {
                throw new Error(`Encountered duplicate value inverting object: "${instance}: ${key} and ${result[instance]}"`);
            }
            result[instance] = key;
        }
    });
    return result;
}
exports.invert = invert;
/**
 * Safely invert an object to be { [key in TValue]: TKey[] }
 * @param obj - The object to invert
 * @returns The inverted object
 */
function invertSafe(obj) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    // Invert
    (0, getEntries_1.getEntries)(obj).forEach(([key, instance]) => {
        // Ensure no undefined values
        if (instance === undefined) {
            throw new Error('inverse found undefined value, this is not supported');
        }
        // Handle array case
        if (Array.isArray(instance)) {
            instance.forEach((listKey) => {
                // Create a new entry
                if (!result[listKey]) {
                    result[listKey] = [key];
                }
                else {
                    // Add to existing
                    result[listKey].push(key);
                }
            });
        }
        else if (!result[instance]) {
            result[instance] = [key];
        }
        else {
            // Add to existing
            result[instance].push(key);
        }
    });
    return result;
}
exports.invertSafe = invertSafe;
//# sourceMappingURL=invert.js.map